import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import toast from 'react-hot-toast';

const RegisterPage = () => {
  const [form, setForm] = useState({ name: '', email: '', password: '', institution: '', phone: '' });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) {
      return toast.error('Password minimal 6 karakter');
    }
    setLoading(true);
    try {
      await register(form);
      toast.success('Pendaftaran berhasil!');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Gagal mendaftar');
    } finally {
      setLoading(false);
    }
  };

  const set = (key) => (e) => setForm(prev => ({ ...prev, [key]: e.target.value }));

  return (
    <div style={{ minHeight: '100vh', display: 'flex', background: 'var(--bg-primary)', position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', inset: 0, overflow: 'hidden', zIndex: 0 }}>
        <div style={{ position: 'absolute', top: '-20%', right: '-10%', width: 600, height: 600, borderRadius: '50%', background: 'radial-gradient(circle, rgba(245,158,11,0.08) 0%, transparent 70%)' }} />
      </div>

      <button onClick={toggleTheme} className="btn btn-icon btn-ghost" style={{ position: 'absolute', top: 20, right: 20, zIndex: 10 }}>
        {theme === 'dark' ? (
          <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" /></svg>
        ) : (
          <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z" /></svg>
        )}
      </button>

      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 24px', zIndex: 1 }}>
        <div style={{ width: '100%', maxWidth: 420 }} className="slide-up">
          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>
              <img src="/logo_ngada.png" alt="Logo Kab Ngada" style={{ width: 52, height: 'auto', objectFit: 'contain' }} />
            </div>
            <h1 style={{ fontSize: '1.5rem', fontWeight: 800, color: 'var(--text-primary)', marginBottom: 4 }}>Daftar Akun</h1>
            <p style={{ fontSize: '0.875rem', color: 'var(--text-secondary)' }}>Bergabung dengan SI-KOPENG — Kab. Ngada</p>
          </div>
          <div className="card" style={{ padding: 32, boxShadow: 'var(--shadow-lg)' }}>
            <form onSubmit={handleSubmit}>
              <div className="form-group" style={{ marginBottom: 14 }}>
                <label className="form-label">Nama Lengkap *</label>
                <input className="form-input" placeholder="Nama lengkap" value={form.name} onChange={set('name')} required />
              </div>
              <div className="form-group" style={{ marginBottom: 14 }}>
                <label className="form-label">Email *</label>
                <input type="email" className="form-input" placeholder="email@ngadakab.go.id" value={form.email} onChange={set('email')} required />
              </div>
              <div className="form-group" style={{ marginBottom: 14 }}>
                <label className="form-label">Password *</label>
                <input type="password" className="form-input" placeholder="Minimal 6 karakter" value={form.password} onChange={set('password')} required />
              </div>
              <div className="form-group" style={{ marginBottom: 14 }}>
                <label className="form-label">Instansi / OPD</label>
                <input className="form-input" placeholder="Nama instansi" value={form.institution} onChange={set('institution')} />
              </div>
              <div className="form-group" style={{ marginBottom: 24 }}>
                <label className="form-label">No. Telepon</label>
                <input className="form-input" placeholder="08xxxxxxxxxx" value={form.phone} onChange={set('phone')} />
              </div>
              <button type="submit" className="btn btn-primary btn-lg" disabled={loading} style={{ width: '100%' }}>
                {loading ? <div className="spinner" style={{ width: 20, height: 20, borderWidth: 2 }} /> : 'Daftar'}
              </button>
            </form>
          </div>
          <p style={{ textAlign: 'center', marginTop: 20, fontSize: '0.875rem', color: 'var(--text-secondary)' }}>
            Sudah punya akun? <Link to="/login" style={{ fontWeight: 600, color: 'var(--text-accent)' }}>Masuk</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
